import { createSlice } from "@reduxjs/toolkit";

interface CVAccessShareState {
	loading: boolean;
	message: string;
}

const name = "cvAccessShare";

export const cvAccessShareSlice = createSlice({
	name,
	initialState: {
		loading: true,
		message: "cvAccessShareText.wait",
	},
	reducers: {
		cvAccessShareRequestSucceeded: (state: CVAccessShareState) => {
			return {
				...state,
				loading: false,
				message: "cvAccessShareText.success",
			};
		},
		cvAccessShareRequestNotFound: (state: CVAccessShareState) => {
			return {
				...state,
				loading: false,
				message: "cvAccessShareText.errorNotFound",
			};
		},
		cvAccessShareRequestConflict: (state: CVAccessShareState) => {
			return {
				...state,
				loading: false,
				message: "cvAccessShareText.errorUsed",
			};
		},
		cvAccessShareRequestForbidden: (state: CVAccessShareState) => {
			return {
				...state,
				loading: false,
				message: "cvAccessShareText.errorCvNotUploaded",
			};
		},
		cvAccessShareRequestFailedOther: (state: CVAccessShareState) => {
			return {
				...state,
				loading: false,
				message: "cvAccessShareText.errorOther",
			};
		},
	},
});

export const {
	cvAccessShareRequestSucceeded,
	cvAccessShareRequestConflict,
	cvAccessShareRequestForbidden,
	cvAccessShareRequestNotFound,
	cvAccessShareRequestFailedOther,
} = cvAccessShareSlice.actions;

export const selectLoading = (state: { cvAccessShare: CVAccessShareState }) =>
	state.cvAccessShare.loading;
export const selectMessage = (state: { cvAccessShare: CVAccessShareState }) =>
	state.cvAccessShare.message;

export default cvAccessShareSlice.reducer;
